// Hàm thiết lập Cookie
import {KEY_MIXPANEL, LOCAL_STORAGE, PATH} from '@utils/Const'
import React from 'react'
import mixpanel from 'mixpanel-browser'
import {datadogRum} from '@datadog/browser-rum'

export const audioRef: any = React.createRef()

function setCookie(cname: string, cvalue: any, exdays: number) {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = `expires=${d.toUTCString()}`
  document.cookie = `${cname}=${cvalue}; ${expires}`
}

// Hàm lấy Cookie
function getCookie(cname: string) {
  const name = `${cname}=`
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1)
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length)
  }
  return ''
}

export const textToSpeech = (txt: string) => {
  return `https://synthesis-service.scratch.mit.edu/synth?locale=en-US&gender=male&text=${txt?.replaceAll(
    ' ',
    '%20',
  )}`
}

export const isLoggedIn = () => {
  const retrievedToken = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)
  return !!retrievedToken
}

export const utils = {
  setCookie,
  getCookie,
}

export const scale = (screenWidth: number | null, designWidth: number) => {
  return (itemWidth: number) => {
    return `${(itemWidth / designWidth) * (screenWidth || designWidth)}px`
  }
}

export const styleByTextTag = (text: string) => {
  const lines = text.split('\n')

  return lines.map((line, lineIndex) => (
    <React.Fragment key={`line-${lineIndex}`}>
      {lineIndex > 0 && <br />}{' '}
      {/* Insert a line break before each line except the first */}
      {processLine(line)}
    </React.Fragment>
  ))
}

const processLine = (line: string) => {
  const regex = /<(\w+)>(.*?)<\/\1>|(\S+)/g
  const matchesArray = Array.from(line.matchAll(regex))
  const result: JSX.Element[] = []

  matchesArray.forEach((match, index) => {
    const [fullMatch, p1, p2, p3] = match
    let words: string[] = []
    let style = ''

    if (p1 && p2) {
      switch (p1) {
        case 'primary':
          style = 'primary-text'
          break
        case 'blue':
          style = 'blue-text'
          break
        case 'yellow':
          style = 'yellow-text'
          break
        case 'red':
          style = 'red-text'
          break
        case 'green':
          style = 'green-text'
          break
        case 'orange':
          style = 'orange-text'
          break
        case 'purple':
          style = 'purple-text'
          break
        case 'b':
          style = 'bold-text'
          break
        case 'mistake':
          style = 'orange-text'
          break
        case 'improve':
          style = 'primary-text'
          break
        case 'r':
          style = 'vocabulary-text practice-sentence'
          break
        case 'g':
          style = 'vocabulary-text'
          break
        default:
          style = ''
          break
      }
      words = p2.split(' ')
    } else if (p3) {
      words = [p3]
    }

    words.forEach((word, wordIndex) => {
      result.push(
        <span key={`word-${index}-${wordIndex}`} className={style}>
          {word + ' '}
        </span>,
      )
    })
  })

  return result
}

export const checkDataForm = (data: any) => {
  const getUserId = () => localStorage.getItem(LOCAL_STORAGE.USER_ID)
  const userId = getUserId()
  let formData = new FormData()
  if (data && !(data instanceof FormData)) {
    Object.keys(data).forEach(key => {
      formData.append(key, data[key])
    })
  }

  if (userId) {
    formData.append('user_id', userId)
  }
  if (data instanceof FormData) {
    data.forEach((value, key) => {
      formData.append(key, value)
    })
  }
  return formData
}

export function getColorScore(score: number) {
  if (score < 50) {
    return 'red'
  } else if (score < 75) {
    return 'orange'
  } else {
    return 'green'
  }
}

export const getUserId = () => localStorage.getItem(LOCAL_STORAGE.USER_ID)

export const getUserPhone = () => localStorage.getItem(LOCAL_STORAGE.USER_PHONE)

export const initDataDog = (userId: string) => {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DATA_DOG_ID || '',
    clientToken: process.env.REACT_APP_DATA_DOG_TOKEN || '',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'us5.datadoghq.com',
    service: `ielts-${process.env.REACT_APP_ENV}`,
    env: process.env.REACT_APP_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  })

  if (!userId) return

  datadogRum.setUser({
    id: userId || 'missing_1',
  })
}

export const initTracking = (userId: string) => {
  try {
    // @ts-ignore
    mixpanel.init(process.env.REACT_APP_KEY_MIXPANEL, {track_pageview: true})
    if (userId) {
      // @ts-ignore
      mixpanel?.identify(userId || '')
    }
  } catch (e) {
    console.log(e)
  }
}
export const trackingPage = (screen_name: string, property = {}) => {
  const data = {page: screen_name}
  const updateData = {
    ...data,
    ...property,
  }
  try {
    mixpanel.track_pageview(updateData)
  } catch (e) {}
}

export const trackingEvent = (event_name: string, property?: any) => {
  mixpanel.track(event_name!, property)
}

export const randomElementIndexInArray = (arr?: any[]) => {
  const newAnswer = [...(arr ?? [])]
  for (let i = newAnswer.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[newAnswer[i], newAnswer[j]] = [newAnswer[j], newAnswer[i]]
  }
  return newAnswer
}

export const playAudio = (url: string, speed = 1) => {
  if (audioRef.current) {
    audioRef.current?.pause()
  }
  audioRef.current = new Audio(url)
  audioRef.current?.play()
  audioRef.current.playbackRate = speed
}

export const pauseAudio = () => {
  audioRef.current?.pause()
}

export const getFeedbackType = (task_type: string) => {
  switch (task_type) {
    case 'LESSON_PART_ONE':
      return 'FINISH_LESSON_PART_ONE'
    case 'LESSON_PART_TWO':
      return 'FINISH_LESSON_PART_TWO'
    case 'LESSON_PART_TWO_NEW':
      return 'FINISH_LESSON_PART_TWO_NEW'
    case 'LESSON_PART_THREE':
      return 'FINISH_LESSON_PART_THREE'
    case 'FAST_TRACK':
      return 'FINISH_FAST_TRACK'
    case 'VOCABULARY':
      return 'FINISH_VOCABULARY'
    case 'MOCK_TEST':
      return 'FINISH_MOCK_TEST'
    case 'REAL_TEST':
      return 'FINISH_REAL_TEST'
    case 'MOCK_TEST_PART_ONE':
      return 'FINISH_MOCK_TEST_PART_ONE'
    case 'MOCK_TEST_PART_TWO':
      return 'FINISH_MOCK_TEST_PART_TWO'
    case 'REAL_TEST_PART_ONE':
      return 'FINISH_REAL_TEST_PART_ONE'
    case 'REAL_TEST_PART_TWO':
      return 'FINISH_REAL_TEST_PART_TWO'
    case 'IPA':
      return 'FINISH_IPA'
    case 'PHRASE_PRACTICE':
      return 'FINISH_PHRASE_PRACTICE'
    case 'SENTENCE_PRACTICE':
      return 'FINISH_SENTENCE_PRACTICE'
    default:
      return ''
  }
}

export const getFeedbackExitFlowType = (path: string) => {
  switch (path) {
    case PATH.CONVERSATION:
      return 'FIRST_TIME_EXIT_LESSON_PART_ONE'
    case PATH.LEARN_PART_TWO:
      return 'FIRST_TIME_EXIT_LESSON_PART_TWO_NEW'
    case PATH.LEARN_PART_THREE:
      return 'FIRST_TIME_EXIT_LESSON_PART_THREE'
    case PATH.LEARN_VOCABULARY:
      return 'FIRST_TIME_EXIT_VOCABULARY'
    case PATH.GYM_PRONOUNCE:
    case PATH.GYM_PAIR:
    case PATH.GYM_PRACTICE:
      return 'FIRST_TIME_EXIT_IPA'
    case PATH.EXAM_ROOM:
      return 'FIRST_TIME_EXIT_MOCK_TEST_PART_ONE'
    case PATH.LEARN_REVISE_ROOM:
      return 'FIRST_TIME_EXIT_PHRASE_PRACTICE'
    case PATH.LEARN_REVISE_SENTENCE:
      return 'FIRST_TIME_EXIT_SENTENCE_PRACTICE'
    default:
      return 'FIRST_TIME_EXIT_LEARNING_FLOW'
  }
}

export const isParamsValid = (params: any[]) => {
  if (!Array.isArray(params)) return false

  return params.every(param => {
    if (param === null || param === undefined || param === '') return false
    // Kiểm tra nếu là object rỗng
    if (typeof param === 'object' && Object.keys(param).length === 0)
      return false
    // Kiểm tra nếu là array rỗng
    if (Array.isArray(param) && param.length === 0) return false
    return true
  })
}

// Thêm hàm kiểm tra Facebook in-app browser
export const isFacebookInAppBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor
  return userAgent.indexOf('FBAN') > -1 || userAgent.indexOf('FBAV') > -1
}
